module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "No-Paragraph-Style-3",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("I honor beginnings. Of all things, I honor beginnings. I believe that what was has always been, and what is has always been, and what will be has always been.")]), _vm._v(" "), _c('p', {
    staticClass: "HALF-SPACE"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—Louis Kahn")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0